"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDataToKeepThisStep = exports.FieldAddStep = void 0;
const __1 = require("../../..");
const FieldAddStep = (props, setThisStep) => {
    setThisStep((prev) => {
        let temp = [...prev];
        temp.push(props.fields);
        return [...temp];
    });
};
exports.FieldAddStep = FieldAddStep;
const FieldDataToKeepThisStep = (props, setKeepData, data, index, setAddIndex) => {
    if ((props === null || props === void 0 ? void 0 : props.parentIndex) >= 0) {
        if (props.grandParentKey === props.parentKey) {
            if (props.FieldReference.current[props.parentIndex][props.parentKey]) {
                let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.parentIndex][props.parentKey]);
                cloneData.splice(index + 1, 0, data);
                setKeepData({
                    [props.parentKey]: (0, __1.FunctionCloneDeep)(cloneData),
                });
                setAddIndex(null);
            }
        }
        else {
            if (props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey]) {
                let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex][props.parentKey]);
                cloneData.splice(index + 1, 0, data);
                const newData = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex]), { [props.grandParentKey]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentIndex]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentIndex]), { [props.parentKey]: cloneData }) }) });
                setKeepData(newData);
                setAddIndex(null);
            }
        }
    }
    else {
        if ((props === null || props === void 0 ? void 0 : props.grandParentIndex) >= 0) {
            let cloneData = (0, __1.FunctionCloneDeep)(props.FieldReference.current[props.grandParentIndex][props.grandParentKey][props.parentKey]);
            cloneData.splice(index + 1, 0, data);
            const newData = Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex]), { [props.grandParentKey]: Object.assign(Object.assign({}, props.FieldReference.current[props.grandParentIndex][props.grandParentKey]), { [props.parentKey]: cloneData }) });
            // console.log("IN PROPS ", {
            //   props,
            //   data,
            //   index,
            //   cloneData,
            // });
            setKeepData(newData);
            setAddIndex(null);
        }
    }
};
exports.FieldDataToKeepThisStep = FieldDataToKeepThisStep;
